module.exports = __webpack_public_path__ + "img/tkn.89521f2a.svg";